import request from '@/utils/request'


/**
 * 获取验证码
 * @param {Object} data
 */
export function getSmsCode(data) {

	return request({
		url: `/api/user/user/getSmsCode`,
		method: "get",
		params: data
	});
}

/**
 * 登录
 * @param {Object} data
 */
export function phoneLoginAuth(data) {

	return request({
		url: `/api/user/user/phoneLoginAuth`,
		method: "post",
		data
	});
}


/**
 * 注册
 * @param {Object} data
 */
export function register(data) {

	return request({
		url: `/api/user/user/register`,
		method: "post",
		data
	});
}
